<template>
  <div class="container">
    <rewards-programs-title />
    <rewards-programs-tabs initial-tab-value="fulfillment" />
    <rewards-programs-fulfillment-channel />
    <div class="separator m-vx2" />
    <div class="t-xl bold m-b">Fulfillment</div>
    <div class="t m-bx2">{{ fulfillmentDesc }}</div>
    <rewards-redemptions-table />
  </div>
</template>

<script setup>
  import { computed, inject, onBeforeMount } from 'vue';
  import { useStore } from 'vuex';
  import { capitalize } from 'lodash';

  const { commit } = useStore();
  const $i18n = inject('$i18n');

  // Copy
  const fulfillmentDesc = `Manually fulfilled ${$i18n.t('shoutouts.reward', { count: 2 })} require an admin to mark them as fulfilled in the table below.`;
</script>
